import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MapPage from "./pages/MapPage";
import PredictionPage from './pages/PredictionPage';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import SaleReviewsPage from './pages/SaleReviewsPage';
import SettingsPage from './pages/SettingsPage';
import ClientsPage from './pages/ClientsPage';
import InvestorOnboardingPage from './pages/InvestorOnboardingPage';
import InvestorsListPage from './pages/InvestorsListPage';
import BuildingsPage from './pages/BuildingsPage';
import BuildingStatsPage from './pages/BuildingStatsPage';
import ListingsPage from './pages/ListingsPage';
import ListingSearchPage from './pages/ListingSearchPage';
import SponsorDealsPage from './pages/SponsorDealsPage';
import SponsorBuildingPage from './pages/SponsorBuildingPage';
import ListingDetailPage from './pages/ListingDetailPage';
import UsersPage from './pages/UsersPage';
import CompScoringPage from './pages/CompScoringPage';
import ZonesPage from './pages/ZonesPage';
import AuditPage from './pages/AuditPage';
import MISPage from './pages/MISPage';
import RentalStatsPage from './pages/RentalStatsPage';
import BuildingEditPage from './pages/BuildingEditPage';
import ClientViewPage from './pages/ClientViewPage';
import UnitMergePage from './pages/UnitMergePage';
import UnitsPage from './pages/UnitsPage';
import CoverageStatsPage from './pages/CoverageStatsPage';
import DocsPage from './pages/DocsPage';
import AlertsPage from './pages/AlertsPage';
import DocViewer from './pages/DocViewer';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import { getRole } from './utils/authToken';

function HomePage() {
  // Third copy of "decode the JWT" removed; the shared helper also handles base64URL payloads,
  // which the inline atob() could throw on.
  return getRole() === "sales" ? <MISPage /> : <SaleReviewsPage />;
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/client/view/:token" element={<ClientViewPage />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <HomePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/pipeline"
          element={
            <PrivateRoute>
              <SaleReviewsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/map"
          element={
            <PrivateRoute>
              <MapPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/predict/:id"
          element={
            <PrivateRoute>
              <PredictionPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/alerts"
          element={
            <PrivateRoute>
              <AlertsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <SettingsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/clients"
          element={
            <PrivateRoute>
              <ClientsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/investors"
          element={
            <PrivateRoute>
              <InvestorsListPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/investors/new"
          element={
            <PrivateRoute>
              <InvestorOnboardingPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/investors/:id/edit"
          element={
            <PrivateRoute>
              <InvestorOnboardingPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/buildings"
          element={
            <PrivateRoute>
              <BuildingsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/buildings/stats"
          element={
            <PrivateRoute>
              <BuildingStatsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/listings"
          element={
            <PrivateRoute>
              <ListingSearchPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/sponsor-deals"
          element={
            <PrivateRoute>
              <SponsorDealsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/sponsor-deals/building/:propertyId"
          element={
            <PrivateRoute>
              <SponsorBuildingPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/data-quality"
          element={
            <PrivateRoute>
              <ListingsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/listing/:id"
          element={
            <PrivateRoute>
              <ListingDetailPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/unit-merge"
          element={
            <PrivateRoute>
              <UnitMergePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/units"
          element={
            <PrivateRoute>
              <UnitsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <UsersPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/comps/:id"
          element={
            <PrivateRoute>
              <CompScoringPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/zones"
          element={
            <PrivateRoute>
              <ZonesPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/audit"
          element={
            <PrivateRoute>
              <AuditPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/mis"
          element={
            <PrivateRoute>
              <MISPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/buildings/:id/edit"
          element={
            <PrivateRoute>
              <BuildingEditPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/rental-stats"
          element={
            <PrivateRoute>
              <RentalStatsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/coverage"
          element={
            <PrivateRoute>
              <CoverageStatsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/docs"
          element={
            <AdminRoute>
              <DocsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/docs/:slug"
          element={
            <AdminRoute>
              <DocViewer />
            </AdminRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
